import React from "react";

import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";

/**
 * Dumb renderer for the "Create factsheet" action button.
 * The container derives tooltip/disabled rules.
 */

const CreateFactSheetButton = ({
  label,
  tooltip,
  disabled,
  onClick,
}) => {
  return (
    <Tooltip title={tooltip || ""} arrow placement="top">
      <span style={{ width: "100%" }}>
        <Button
          data-cy="create-factsheet"
          style={{
            width: "100%",
            marginTop: 15,
            marginBottom: 25,
          }}
          color="primary"
          variant="contained"
          onClick={onClick}
          disabled={Boolean(disabled)}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};

export default CreateFactSheetButton;
